import { BSON } from 'mongodb-stitch-browser-sdk'

import { db } from '@/plugins/stitch'
import store from '@/store'

function fetch (query, options = {}) {
  const url = this.getURL(this.getFetchRoute())

  this.onFetch()

  let ref = db.collection(url)

  if (!query) {
    throw new Error('fetch() argument cannot be null')
  }

  if (Array.isArray(query)) {
    ref = ref.aggregate(query).toArray()
  } else if (typeof query === 'object') {
    ref = ref.find(query, options).toArray()
  } else {
    ref = ref.findOne({ _id: new BSON.ObjectID(query) })
  }

  return new Promise((resolve, reject) => {
    ref
      .then(doc => {
        this.onFetchSuccess(doc)
        resolve(doc)
      })
      .catch(err => {
        this.onFetchFailure()
        reject(err)
      })
  })
}

async function save (params = {}) {
  const collection = this.getURL(this.getSaveRoute(), params)

  try {
    await this.onSave()
  } catch (error) {
    store.commit('notifyError', { message: `Invalid ${this.getModelName()} data`, error })
    return
  }

  let ref = db.collection(collection)
  let data = this.getSaveData()

  if (this.autoFields) {
    const now = new Date().getTime()
    if (this.isNew()) {
      data.createdAt = now
      data.createdBy = store.getters['user/currentUser'].id
    }

    data.updatedAt = now
  }

  if (this.isNew()) {
    if (data.organization !== undefined) {
      data.organization = store.getters['organizations/currentOrganization'].id
    }
    ref = ref.insertOne(data)
  } else {
    ref = ref.updateOne(
      { _id: new BSON.ObjectID(this.identifier()) },
      { $set: data }
    )
  }

  if (!params.skipLog) {
    logFeed(
      this.isNew() ? 'created' : 'updated',
      this.getModelName().toLowerCase(),
      this.title || this.name,
      this.project)
  }

  return ref
    .then(result => {
      if (result.insertedId) { data.id = result.insertedId.toString() }
      this.onSaveSuccess(data)
      store.commit('notify', `${this.getModelName()} successfully saved`)
    })
    .catch(error => {
      this.onSaveFailure(error)
      store.commit('notifyError', { message: `Can't save ${this.getModelName()}`, error })
    })
}

function _delete (params) {
  const collection = this.getURL(this.getDeleteRoute(), params)

  this.onDelete()

  db.collection(collection)
    .deleteOne({ _id: new BSON.ObjectID(this.identifier()) })
    .then(() => {
      this.onDeleteSuccess()
      store.commit('notify', `${this.getModelName()} successfully deleted`)
    })
    .catch(error => {
      this.onDeleteFailure()
      store.commit('notifyError', { message: `Can't delete ${this.getModelName()}`, error })
    })
}

/**
 *  Luca  created  activity Align requirements 2 hours ago
 * | who | action | entity |       name       |    when   |
 */
function logFeed (action, entity, name = null, project = null) {
  // db
  //   .collection('feed')
  //   .insertOne({
  //     who: store.getters['user/currentUid'],
  //     action,
  //     entity,
  //     name,
  //     when: new Date().getTime(),
  //     organization: store.getters['user/currentOrganization'].id,
  //     project
  //   })
}

export {
  fetch,
  save,
  _delete
}
